import { useCallback, useState } from 'react';

interface UseFamilySubfamilyLogicProps {
	initialFamilyId?: number;
	initialSubfamilyId?: number;
	initialProductModelId?: number;
}

interface UseFamilySubfamilyLogicReturn {
	familyId: number | undefined;
	subfamilyId: number | undefined;
	productModelId: number | undefined;
	handleOnChangeFamily: (value: any) => void;
	handleOnChangeSubfamily: (value: any) => void;
	handleOnChangeProductModel: (value: any) => void;
	isDisabledSubfamilyAutocomplete: () => boolean;
	isDisabledProductModelAutocomplete: () => boolean;
	shouldClearAutocompleteSubfamily: () => boolean;
	shouldClearAutocompleteProductModel: () => boolean;
}

export const useFamilySubfamilyLogic = ({
	initialFamilyId,
	initialSubfamilyId,
	initialProductModelId,
}: UseFamilySubfamilyLogicProps = {}): UseFamilySubfamilyLogicReturn => {
	const [familyId, setFamilyId] = useState<number | undefined>(
		initialFamilyId
	);
	const [subfamilyId, setSubfamilyId] = useState<number | undefined>(
		initialSubfamilyId
	);
	const [productModelId, setProductModelId] = useState<number | undefined>(
		initialProductModelId
	);

	const handleOnChangeFamily = useCallback(
		(value: any) => {
			const newFamilyId = value?.id;

			if (subfamilyId && newFamilyId !== familyId) {
				setSubfamilyId(undefined);
			}

			if (
				productModelId &&
				newFamilyId !== familyId &&
				!value?.nome_familia
			) {
				setProductModelId(undefined);
			}

			setFamilyId(newFamilyId);
		},
		[subfamilyId, productModelId, familyId]
	);

	const handleOnChangeSubfamily = useCallback(
		(value: any) => {
			setSubfamilyId(value?.id);

			if (value?.familia?.id && !familyId) {
				setFamilyId(value.familia.id);
			}

			if (
				productModelId &&
				value?.id !== subfamilyId &&
				!value?.nome_sub_familia
			) {
				setProductModelId(undefined);
			}
		},
		[familyId, productModelId, subfamilyId]
	);

	const handleOnChangeProductModel = useCallback(
		(value: any) => {
			setProductModelId(value?.id);

			if (value?.familia?.id && !familyId) {
				setFamilyId(value.familia.id);
			}

			if (value?.sub_familia?.id && !subfamilyId) {
				setSubfamilyId(value.sub_familia.id);
			}
		},
		[familyId, subfamilyId]
	);

	const isDisabledSubfamilyAutocomplete = useCallback(() => {
		return false;
	}, []);

	const isDisabledProductModelAutocomplete = useCallback(() => {
		return false;
	}, []);

	const shouldClearAutocompleteSubfamily = useCallback(() => {
		if (!subfamilyId && familyId) {
			return true;
		}

		return false;
	}, [familyId, subfamilyId]);

	const shouldClearAutocompleteProductModel = useCallback(() => {
		if (!productModelId && (familyId || subfamilyId)) {
			return true;
		}

		return false;
	}, [familyId, subfamilyId, productModelId]);

	return {
		familyId,
		subfamilyId,
		productModelId,
		handleOnChangeFamily,
		handleOnChangeSubfamily,
		handleOnChangeProductModel,
		isDisabledSubfamilyAutocomplete,
		isDisabledProductModelAutocomplete,
		shouldClearAutocompleteSubfamily,
		shouldClearAutocompleteProductModel,
	};
};
